import React, { useState, useEffect, useCallback } from 'react';
import FilterPill from '../FilterPill/FilterPill';
import './ConditionSelector.css';

interface ConditionSelectorProps {
  onChange?: (activeConditions: string[]) => void;
  initialConditions?: string[];
}

const defaultConditions = ['NM', 'LP', 'MP', 'HP']; // Near Mint, Lightly Played, Moderately Played, Heavily Played

const ConditionSelector: React.FC<ConditionSelectorProps> = ({ 
  onChange,
  initialConditions 
}) => {
  const getInitialState = useCallback(() => {
    return defaultConditions.reduce((acc, cond) => {
      // If initialConditions is provided, only activate those conditions
      // Otherwise, activate all default conditions
      const isActive = initialConditions 
        ? initialConditions.includes(cond)
        : true;
      return { ...acc, [cond]: isActive };
    }, {} as Record<string, boolean>);
  }, [initialConditions]);
  
  const [active, setActive] = useState<Record<string, boolean>>(getInitialState());
  
  // Update state when props change
  useEffect(() => {
    setActive(getInitialState());
  }, [getInitialState]);

  const toggle = (cond: string) => {
    const updated = { ...active, [cond]: !active[cond] };
    setActive(updated);
    onChange?.(Object.keys(updated).filter((k) => updated[k]));
  };

  return (
    <div className="condition-selector">
      <label>Condition:</label>
      <div className="condition-selector-buttons">
        {defaultConditions.map((cond) => (
          <FilterPill
            key={cond}
            label={cond}
            active={active[cond]}
            onToggle={() => toggle(cond)}
          />
        ))}
      </div>
    </div>
  );
};

export default ConditionSelector;
